import styled from "styled-components";

export const Container = styled.div`
  background-color: black;
  width: 100vw;
  height: 100vh;
`;

export const ConnectingContainer = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  height: 60vh;
  width: 100vw;
  align-items: center;
  gap: 9vh;
  @media (orientation: landscape) {
    gap: 2vh;
    height: 20vh;
  }

  &.hu-view-container {
    @media (orientation: landscape) {
      gap: 2vh;
      height: 60vh;
    }
  }
`;

export const QueueTextContainer = styled.div`
  color: white;
  text-wrap: wrap;
  display: flex;
  flex-direction: row;
  justify-content: center;
  width: 80%;
  font-family: "Source Sans Pro";
  text-align: center;
  font-feature-settings: "clig" off, "liga" off;
  font-size: 24px;
  font-style: normal;
  font-weight: 600;
  line-height: 118%;
`;

export const EndButtonContainer = styled.div`
  position: absolute;
  width: 100%;
  bottom: 0;
  justify-content: center;
  display: flex;
  flex-direction: row;
  height: 80px;
  justify-content: center;
  align-items: center;
  align-self: stretch;
  box-sizing: border-box;
  padding: 8px;
  gap: 32px;
  .normalBtn {
    box-shadow: 0px 2px 6px 0px rgba(0, 0, 0, 0.12);
    background: var(--white-100, #fff);
    width: 48px;
    height: 48px;
  }
  .cancelBtn {
    box-shadow: 0px 2px 6px 0px rgba(0, 0, 0, 0.12);
    background: var(--critical-default, #df352c);
    width: 48px;
    height: 48px;
    border-radius: 12px;
  }
  .end-text {
    color: rgba(255, 255, 255, 0.6);
    text-align: center;
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: 16px;
  }
`;
